import controller from './rebates-reimbursements.controller.js';

let rebatesReimbursementsModule = angular.module('rebates-reimbursements', [])

    .directive('rebatesReimbursements', () => {
        'ngInject';

        return {
            retrict: 'EA',
            controller: controller,
            controllerAs: '$ctrl',
            scope: {},
            bindToController: true,
            transclude: true,
            link: (scope, element, attrs, ctrlr, transclude) => {
                transclude(scope, (clone, scope) => {
                    element.append(clone);
                });
            }
        };
    })

    .name;

export default rebatesReimbursementsModule;



// WEBPACK FOOTER //
// ./src/app/angular/rebates-reimbursements/rebates-reimbursements.js